import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { jsx } from '@emotion/core';
import { Component } from 'react';
import { Container, InputContainer } from './styledComponents';
import { FieldError } from '../FieldError';
import { isFunction } from '../../../utils';

class CustomInputContainer extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      isFocused: false
    });

    _defineProperty(this, "focusAndBlurHandler", e => {
      e.persist();
      var {
        type
      } = e;
      this.setState(() => ({
        isFocused: type === 'focus'
      }));
      var handler = this.props["".concat(type, "Handler")];

      if (isFunction(handler)) {
        handler(e);
      }
    });
  }

  render() {
    var {
      children,
      containerStyleOverrides,
      displayError,
      error,
      inputId,
      inputContainerStyleOverrides
    } = this.props;
    var displayErrorIsTrue = displayError === true;
    var displayErrorMessage = (displayErrorIsTrue || Boolean(displayError === null || displayError === void 0 ? void 0 : displayError.message)) && (error === null || error === void 0 ? void 0 : error.length);
    var displayErrorStyling = displayErrorIsTrue || !!(displayError !== null && displayError !== void 0 && displayError.styling);
    return jsx(Container, {
      css: containerStyleOverrides
    }, jsx(InputContainer, {
      css: inputContainerStyleOverrides,
      hasError: displayErrorStyling,
      isFocused: this.state.isFocused
    }, isFunction(children) ? children(this.focusAndBlurHandler) : children), displayErrorMessage && jsx(FieldError, {
      id: "".concat(inputId, "-error")
    }, error));
  }

}

export { CustomInputContainer };